module.exports = __webpack_public_path__ + "static/kunsthalloslo@2x-0cd9b00c24f3bc4368ad32264313156b.png";